import clsx from 'clsx';
import { CustomerRequest, GuestDetail } from '@camp67/model';
import { useCallback } from 'react';

type PrimaryContactProps = {
  primaryContact: CustomerRequest;
  guests: GuestDetail[];
  onChange: (id: string) => void;
  messages: {
    primaryContactLabel: string;
    selectPrimaryContact: string;
  };
};

export const PrimaryContact = ({
  guests,
  primaryContact,
  onChange,
  messages,
}: PrimaryContactProps) => {
  const handleChange: React.ChangeEventHandler<HTMLSelectElement> = useCallback(
    (e) => {
      onChange(e.target.value);
    },
    [onChange],
  );

  return (
    <div className={'w-full py-3 px-5 bg-gray-100 rounded-md'}>
      <p className="font-sans text-gray-250 font-regular text-sm">
        {messages.primaryContactLabel}
      </p>
      <select
        className={clsx(
          'w-full bg-gray-100 text-base md:text-base rounded-md h-full m-0 -ml-1 mt-1 p-0 outline-none border-none cursor-pointer focus-within:bg-blue-100',
          {
            'text-gray-400': primaryContact.id === 'none',
          },
        )}
        onChange={handleChange}
        value={primaryContact.id}
      >
        <option value="none">{messages.selectPrimaryContact}</option>
        {guests.map((guest) => (
          <option value={guest.id} key={guest.id}>
            {guest.name}
          </option>
        ))}
      </select>
    </div>
  );
};
